import type {SyncIntegration} from '@cohort/merchants/apps';
import TalonOneSyncConfigComponent from '@cohort/merchants/apps/talon-one/sync/SyncConfigComponent';
import type {TalonOneSyncStruct} from '@cohort/shared/apps/talon-one/sync';
import {TalonOneSyncSpec} from '@cohort/shared/apps/talon-one/sync';

export const TalonOneSyncIntegration: SyncIntegration<TalonOneSyncStruct> = {
  spec: TalonOneSyncSpec,
  syncConfigComponent: TalonOneSyncConfigComponent,
};
